// extracted by mini-css-extract-plugin
module.exports = {"radio-button":"TariffCalculatorBlockingTime_radio-button_3Khln"};